// extracted by mini-css-extract-plugin
module.exports = {"root":"Settings_root__XI8JZ","search":"Settings_search__1gP1-","filter":"Settings_filter__3fdzk"};